import { CarbonIntensity } from 'src/modules/carbon-intensity/types/CarbonIntensity';
import { createTrigger } from 'src/utils/createTrigger';

export const CARBON_INTENSITY_FETCH =
  createTrigger<CarbonIntensity[], void>('CARBON_INTENSITY_FETCH');

export const CARBON_INTENSITY_RESET =
  createTrigger<void, void>('CARBON_INTENSITY_RESET');
